import { alpha } from '@mui/material';
import { clamp } from '@ui/style/clamp-calculator';
import { useResponsive } from '@ui/style/useResponsive';
export const useFileUploaderStyles = (theme) => {
    const { isMobile } = useResponsive();
    return {
        container: {
            display: 'flex',
            flexDirection: 'column',
            gap: theme.spacing(1.5),
            width: '100%'
        },
        dropZone: {
            display: 'flex',
            flexDirection: 'column',
            borderRadius: '8px',
            border: `1px dashed ${alpha(theme.palette.grey[500], 0.2)}`,
            padding: clamp.calculate(4, 32),
            gap: theme.spacing(3),
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: alpha(theme.palette.grey[500], 0.08),
            width: '100%',
            boxSizing: 'border-box',
            cursor: 'pointer'
        },
        uploadImage: {
            cursor: 'pointer',
            px: isMobile ? 5 : clamp.calculate(8, 32),
            border: '1px solid red'
        },
        uploadTextBox: {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            gap: theme.spacing(1),
            cursor: 'pointer',
            maxWidth: '100%',
            textAlign: 'center'
        },
        uploadTitle: {
            textAlign: 'center',
            maxWidth: '100%',
            fontSize: clamp.calculate(12, 18)
        },
        uploadSubtitle: {
            textAlign: 'center',
            color: theme.palette.text.secondary,
            fontSize: clamp.calculate(8, 14),
            fontWeight: 400
        },
        infoText: {
            display: 'flex',
            justifyContent: 'center',
            textAlign: 'center',
            marginTop: 0
        }
    };
};
